import { Roles } from '../../../../auth/roles.enum';
import { MenuItem } from './menu-item';

export const FLEET_MANAGER: MenuItem[] = [
	{
		primaryText: 'Dashboard',
		routerLink: '/fleet-manager/dashboard',
		icon: 'home',
	},
	{
		primaryText: 'Overview',
		routerLink: '/fleet-manager/overview',
		icon: 'home',
	},
	{
		primaryText: 'Reporting',
		routerLink: '/fleet-manager/reports',
		icon: 'chart-line',
	},
	{
		primaryText: 'Report Designer',
		routerLink: '/fleet-manager/report-designer',
		icon: 'paint-brush',
		roles: [Roles.Developer, Roles.TsReportDesigner],
	},
	{
		primaryText: 'Notifications',
		routerLink: null,
		icon: 'bell',
		children: [
			{
				primaryText: 'Pending',
				routerLink: '/fleet-manager/notifications/pending',
				icon: 'bell-exclamation',
				queue: 'notifications',
			},
			{
				primaryText: 'Approved',
				routerLink: '/fleet-manager/notifications/approved',
				icon: 'bell-plus',
				queue: 'notificationsErrors',
			},
			{
				primaryText: 'Rejected',
				routerLink: '/fleet-manager/notifications/rejected',
				icon: 'bell-slash',
			},
		],
	},
	{
		primaryText: 'Company',
		routerLink: '/fleet-manager/companies',
		icon: 'truck',
		children: [
			{
				primaryText: 'Service Subscription',
				routerLink: '/fleet-manager/companies/service-subscription',
				icon: 'paper-plane',
			},
		],
	},
	{
		primaryText: 'Contacts Directory',
		routerLink: '/fleet-manager/contacts',
		icon: 'users',
	},
	{
		primaryText: 'Reminders',
		routerLink: '/fleet-manager/reminders',
		icon: 'clock-rotate-left',
		queue: 'reminders',
	},
	{
		primaryText: 'IFTA / MTR',
		routerLink: null,
		icon: 'road',
		isNavigable: false,
		children: [
			{
				primaryText: 'Mileage / Fuel',
				routerLink: '/fleet-manager/ifta-mtr/mileage-fuel',
				icon: 'gas-pump',
			},
			{
				primaryText: 'Tax Reports',
				routerLink: '/fleet-manager/ifta-mtr/tax-report',
				icon: 'file-invoice-dollar',
			},
			{
				primaryText: 'Odometer Search',
				routerLink: '/fleet-manager/ifta-mtr/odometer-search',
				icon: 'gauge-high',
			},
			{
				primaryText: 'IFTA Uploader',
				routerLink: '/fleet-manager/ifta-mtr/ifta-uploader',
				roles: [Roles.TsIFTAUploader, Roles.TsAdmin, Roles.Developer],
				icon: 'file-csv',
			},
		],
	},
	{
		primaryText: 'Billing',
		routerLink: null,
		icon: 'file-invoice-dollar',
		children: [
			{
				primaryText: 'Invoices',
				routerLink: '/fleet-manager/billing/invoice-list',
				icon: 'file-invoice',
			},
			{
				primaryText: 'Charges',
				routerLink: '/fleet-manager/billing/charges',
				icon: 'money-bill-wave',
			},
			{
				primaryText: 'Statements',
				routerLink: '/fleet-manager/billing/statements',
				icon: 'receipt',
			},
			{
				primaryText: 'Manual Billing (US Mail)',
				routerLink: '/fleet-manager/billing/manual-billing',
				icon: 'envelope',
			},
			{
				primaryText: 'Archived Invoices',
				routerLink: '/fleet-manager/billing/archived-invoice-list',
				icon: 'archive',
			},
		],
	},
	{
		primaryText: 'Accounting',
		routerLink: null,
		icon: 'calculator',
		children: [
			{
				primaryText: 'ACH Queues',
				routerLink: null,
				icon: 'building-columns',
				roles: [Roles.TsAdmin, Roles.Developer, Roles.TSInternalAccounting],
				children: [
					{
						primaryText: 'Pending',
						routerLink: '/fleet-manager/ach/pending',
						icon: 'business-time',
						roles: [Roles.TsAdmin, Roles.Developer, Roles.TSInternalAccounting],
					},
					{
						primaryText: 'Approved',
						routerLink: '/fleet-manager/ach/approve',
						icon: 'arrows-spin',
						roles: [Roles.TsAdmin, Roles.Developer, Roles.TSInternalAccounting],
					},
					{
						primaryText: 'Sent',
						routerLink: '/fleet-manager/ach/sent',
						icon: 'share',
						roles: [Roles.TsAdmin, Roles.Developer, Roles.TSInternalAccounting],
					},
					{
						primaryText: 'Returned',
						routerLink: '/fleet-manager/ach/returned',
						icon: 'reply',
						roles: [Roles.TsAdmin, Roles.Developer, Roles.TSInternalAccounting],
					},
				],
			},
			{
				primaryText: 'Wire Queues',
				routerLink: null,
				icon: 'landmark',
				roles: [Roles.TsAdmin, Roles.Developer, Roles.TSInternalAccounting],
				children: [
					{
						primaryText: 'Pending',
						routerLink: '/fleet-manager/wires/pending',
						icon: 'business-time',
						roles: [Roles.TsAdmin, Roles.Developer, Roles.TSInternalAccounting],
					},
					{
						primaryText: 'Approved',
						routerLink: '/fleet-manager/wires/approve',
						icon: 'arrows-spin',
						roles: [Roles.TsAdmin, Roles.Developer, Roles.TSInternalAccounting],
					},
					{
						primaryText: 'Sent',
						routerLink: '/fleet-manager/wires/sent',
						icon: 'share',
						roles: [Roles.TsAdmin, Roles.Developer, Roles.TSInternalAccounting],
					},
					{
						primaryText: 'Returned',
						routerLink: '/fleet-manager/wires/returned',
						icon: 'reply',
						roles: [Roles.TsAdmin, Roles.Developer, Roles.TSInternalAccounting],
					},
				],
			},
			{
				primaryText: 'Terms',
				routerLink: '/fleet-manager/accounting/terms-list',
				icon: 'handshake',
			},
			{
				primaryText: 'Company Terms\r\n',
				routerLink: '/fleet-manager/accounting/company-terms',
				icon: 'building-user',
			},
			{
				primaryText: 'Payments',
				routerLink: '/fleet-manager/accounting/payments-list',
				icon: 'money-check-dollar',
			},
			{
				primaryText: 'Payment Batch',
				routerLink: '/fleet-manager/accounting/payment-batches',
				icon: 'layer-group',
			},
			{
				primaryText: 'Payment Assignment',
				routerLink: '/fleet-manager/accounting/payment-assignment',
				icon: 'hand-holding-dollar',
			},
		],
	},
	{
		primaryText: 'WorkFlows',
		routerLink: null,
		icon: 'diagram-project',
		children: [
			{
				primaryText: 'Active',
				routerLink: '/fleet-manager/workflows/prepay',
				icon: 'money-bill-1-wave',
			},
			{
				primaryText: 'Completed',
				routerLink: '/fleet-manager/workflows/completed',
				icon: 'badge-check',
			},
			{
				primaryText: 'Inactive',
				routerLink: '/fleet-manager/workflows/inactive',
				icon: 'power-off',
			},
		],
	},
	{
		primaryText: 'Admin',
		routerLink: null,
		icon: 'shield-halved',
		roles: [Roles.TsAdmin, Roles.Developer],
		children: [
			{
				primaryText: 'Accounting Reports',
				routerLink: '/fleet-manager/admin/accounting-reports',
				icon: 'chart-pie',
				children: [
					{
						primaryText: 'Aging By Client',
						routerLink:
							'/fleet-manager/admin/accounting-reports/aging-by-client',
						icon: 'hourglass-end',
					},
				],
			},
			{
				primaryText: 'ACH & CC Accounts',
				routerLink: '/fleet-manager/admin/ach-cc',
				icon: 'building-columns',
				roles: [Roles.TsAdmin, Roles.Developer, Roles.TSInternalAccounting],
			},
			{
				primaryText: 'Audit Notes',
				routerLink: '/fleet-manager/admin/audit-notes',
				icon: 'clipboard-list',
				roles: [Roles.TsAdmin, Roles.Developer],
			},
			{
				primaryText: 'Chart Of Accounts',
				routerLink: '/fleet-manager/admin/chart-of-accounts',
				icon: 'chart-column',
			},
			{
				primaryText: 'Deprecated',
				routerLink: '/fleet-manager/admin/deprecated',
				icon: 'trash',
				children: [
					{
						primaryText: 'Document Types',
						routerLink: '/fleet-manager/admin/deprecated/documenttypelist',
						icon: 'folder-tree',
					},
					{
						primaryText: 'Manual Entry',
						routerLink: '/fleet-manager/admin/deprecated/manual-entry',
						icon: 'keyboard',
					},
					{
						primaryText: 'Safety-old',
						routerLink: '/fleet-manager/admin/deprecated/safety-old',
						icon: 'list-alt',
					},
				],
			},
			{
				primaryText: 'IFTA Rates',
				routerLink: '/fleet-manager/admin/ifta-rate-list',
				icon: 'percent',
			},
			{
				primaryText: 'Ins. Agents',
				routerLink: '/fleet-manager/admin/insurance-agents',
				icon: 'user-tie',
			},
			{
				primaryText: 'Insurance',
				routerLink: '/fleet-manager/admin/insurance-list',
				icon: 'umbrella',
			},
			{
				primaryText: 'Journal Entries - QB',
				routerLink: '/fleet-manager/admin/journal-entries',
				icon: 'book-journal-whills',
			},
			{
				primaryText: 'Process Service Agent',
				routerLink: '/fleet-manager/admin/process-service-agents',
				icon: 'gavel',
			},
			{
				primaryText: 'Role Management',
				routerLink: null,
				icon: 'users-gear',
				roles: [Roles.TsAdmin, Roles.Developer],
				children: [
					{
						primaryText: 'Document Permissions',
						routerLink: '/fleet-manager/manage-documents',
						roles: [Roles.TsAdmin, Roles.Developer],
						icon: 'file',
					},
					{
						primaryText: 'Report Permissions',
						routerLink: '/fleet-manager/manage-reports',
						roles: [Roles.TsAdmin, Roles.Developer],
						icon: 'chart-column',
					},
					{
						primaryText: 'User Admin',
						routerLink: '/fleet-manager/users/list',
						icon: 'user',
					},
				],
			},
			{
				primaryText: 'Service Codes',
				routerLink: '/fleet-manager/admin/service-codes',
				icon: 'barcode',
			},
			{
				primaryText: 'Tax Rates',
				routerLink: null,
				icon: 'percentage',
				children: [
					{
						primaryText: 'Fuel Tax',
						routerLink: '/fleet-manager/admin/tax-rates/fuel-tax',
						icon: 'gas-pump',
					},
					{
						primaryText: 'Mileage Tax',
						routerLink: '/fleet-manager/admin/tax-rates/mileage-tax',
						icon: 'route',
					},
				],
			},
			{
				primaryText: 'UCR Rates',
				routerLink: '/fleet-manager/admin/ucr-list',
				icon: 'money-bill-trend-up',
			},
			{
				primaryText: 'Unit Weight Defaults',
				routerLink: '/fleet-manager/admin/unit-weight-defaults',
				icon: 'weight-hanging',
				roles: [Roles.TsAdmin, Roles.Developer],
			},
			{
				primaryText: 'User Page Tracking',
				routerLink: '/fleet-manager/admin/user-page-tracking/live',
				icon: 'camera-cctv',
				roles: [Roles.TsAdmin, Roles.Developer, Roles.TSInternalAccounting],
				children: [
					{
						primaryText: 'Historical',
						routerLink: '/fleet-manager/admin/user-page-tracking/historical',
						icon: 'clock-rotate-left',
					},
				],
			},
			{
				primaryText: 'Vendors',
				routerLink: '/fleet-manager/admin/vendor-list',
				icon: 'store',
			},
		],
	},
	{
		primaryText: '2290',
		routerLink: '/fleet-manager/form2290/requested-filings',
		icon: 'file-contract',
	},
	{
		primaryText: 'Checklist',
		routerLink: '/fleet-manager/checklist',
		icon: 'check-square-o',
		children: [
			{
				primaryText: 'Incomplete Checklists',
				routerLink: '/fleet-manager/checklist/incomplete',
				icon: 'list-check',
			},
			{
				primaryText: 'Missing Checklists',
				routerLink: '/fleet-manager/checklist/missing',
				icon: 'clipboard-question',
			},
		],
	},
	{
		primaryText: 'Safety',
		routerLink: '/fleet-manager/safety-documents',
		icon: 'list-alt',
	},
	{
		primaryText: 'ELD',
		routerLink: null,
		icon: 'flux-capacitor',
		isNavigable: false,
		children: [
			{
				primaryText: 'ELD Inventory',
				routerLink: '/fleet-manager/eld-inventory',
				icon: 'flux-capacitor',
			},
			{
				primaryText: 'ELD Add Item',
				routerLink: '/fleet-manager/eld-add-inventory',
				icon: 'flux-capacitor',
				roles: [Roles.TSELDManager, Roles.Developer, Roles.TsAdmin]
			},
			{
				primaryText: 'ELD Rates',
				routerLink: '/fleet-manager/eld-rates',
				icon: 'dollar-sign',
				roles: [Roles.TsAdmin, Roles.Developer]
			}
		],
	},
	{
		primaryText: 'Samsara',
		routerLink: null,
		icon: 'truck-clock',
		isNavigable: false,
		children: [
			{
				primaryText: 'Unit IFTA Queue',
				routerLink: '/fleet-manager/samsara-ifta',
				icon: 'tachograph-digital',
			},
			{
				primaryText: 'Unit Odometer Queue',
				routerLink: '/fleet-manager/samsara-odometer',
				icon: 'gauge-high',
			},
			{
				primaryText: 'Completed Queue',
				routerLink: '/fleet-manager/samsara-completed',
				icon: 'clipboard-check',
			},
			{
				primaryText: 'Samsara-FM Connection',
				routerLink: '/fleet-manager/samsara-relationship',
				icon: 'link-horizontal',
			},
		],
	},
];

export const PORTAL: MenuItem[] = [
	{
		primaryText: 'Financial Dashboard',
		routerLink: '/portal/dashboard',
		icon: 'tachometer',
	},
	{
		primaryText: 'Industry Dashboard',
		routerLink: '/portal/industry-dashboard',
		icon: 'tachometer',
	},
	{
		primaryText: 'Reporting',
		routerLink: '/portal/reports',
		icon: 'chart-line',
	},
	{
		primaryText: 'Report Designer',
		routerLink: '/portal/report-designer',
		icon: 'paint-brush',
		roles: [Roles.Developer, Roles.PortalReportDesigner],
	},
	{
		primaryText: 'Notifications',
		routerLink: null,
		icon: 'bell',
		children: [
			{
				primaryText: 'Pending',
				routerLink: '/portal/notifications/pending',
				icon: 'bell-exclamation',
				queue: 'notifications',
			},
			{
				primaryText: 'Approved',
				routerLink: '/portal/notifications/approved',
				icon: 'bell-plus',
				queue: 'notificationsErrors',
			},
			{
				primaryText: 'Rejected',
				routerLink: '/portal/notifications/rejected',
				icon: 'bell-slash',
			},
		],
	},
	{
		primaryText: 'Carriers',
		routerLink: '/portal/carrier-list',
		icon: 'user',
	},
	{
		primaryText: 'Brokers',
		routerLink: '/portal/broker-list',
		icon: 'user',
	},
	{
		primaryText: 'Contacts',
		routerLink: '/portal/contacts',
		icon: 'users',
	},
	// {
	// 	primaryText: 'Reminders',
	// 	routerLink: '/portal/reminders',
	// 	icon: 'clock-rotate-left',
	// 	queue: 'reminders',
	// },
	{
		primaryText: 'Aladdin Credit Check',
		routerLink: '/portal/credit-check',
		icon: 'truck-fast',
		excludeRoles: [Roles.CreditCheckDisabled],
	},
	{
		primaryText: 'Completed Requests',
		routerLink: '/portal/completed-requests',
		icon: 'circle-check',
		excludeRoles: [Roles.CreditCheckDisabled],
	},
	{
		primaryText: 'Credit Check Admin',
		routerLink: null,
		icon: 'shield-keyhole',
		roles: [Roles.PortalAdmin, Roles.Developer],
		children: [
			{
				primaryText: 'Credit Request Queue',
				routerLink: '/portal/credit-request-queue',
				queue: 'internal',
				icon: 'box-archive',
			},
			{
				primaryText: 'New Broker Queue',
				routerLink: '/portal/new-broker-queue',
				queue: 'external',
				icon: 'list',
			},
			{
				primaryText: 'Update Credit Queue',
				routerLink: '/portal/update-credit-queue',
				queue: 'update',
				icon: 'file-signature',
			},
			{
				primaryText: 'Grading Audit',
				routerLink: '/portal/grading-audit',
				icon: 'clock-rotate-left',
			},
			{
				primaryText: 'Custom Grading',
				routerLink: '/portal/grading-override',
				icon: 'spell-check',
			},
		],
	},
	{
		primaryText: 'Top Approved Brokers',
		routerLink: '/portal/top-brokers',
		icon: 'check-circle-o',
	},
	{
		primaryText: 'No-Buy Brokers',
		routerLink: '/portal/no-buy-brokers',
		icon: 'square-xmark',
	},
	{
		primaryText: 'Non-Recourse Brokers',
		routerLink: '/portal/non-recourse-brokers',
		icon: 'clipboard-check',
	},
	{
		primaryText: 'Invoices',
		routerLink: '/portal/invoicelisting',
		icon: 'usd',
	},
	// {
	// 	primaryText: 'OCR Admin',
	// 	routerLink: '/portal/ocr-queue',
	// 	icon: 'file-shield',
	// },
	{
		primaryText: 'Processes',
		routerLink: null,
		icon: 'sitemap',
		children: [
			{
				primaryText: 'Invoice Assignment',
				routerLink: '/portal/invoiceassignment',
				icon: 'file-invoice',
			},
			{
				primaryText: 'NOA',
				routerLink: null,
				icon: 'file-signature',
				// TODO: secure
				children: [
					{
						primaryText: 'NOA Followup',
						routerLink: '/portal/noafollowup',
						icon: 'calendar-check',
					},
					{
						primaryText: 'NOA Client Exceptions',
						routerLink: '/portal/noaclientexceptions',
						icon: 'triangle-exclamation',
					},
				],
			},
			{
				primaryText: '3rd Party Assignment',
				routerLink: '/portal/thirdpartyinvoiceassignment',
				icon: 'people-arrows',
			},
			{
				primaryText: 'HubSpot - Carrier Match',
				routerLink: '/portal/hubspot/carrier-match',
				icon: 'handshake',
			},
			{
				primaryText: 'Payment Details',
				routerLink: '/portal/payments',
				icon: 'line-chart',
			}
		],
	},
	{
		primaryText: 'IT',
		routerLink: null,
		icon: 'desktop',
		roles: [Roles.PortalAdmin, Roles.Developer],
		children: [
			{
				primaryText: 'Admin Message',
				routerLink: '/portal/AdminMessageBoard',
				icon: 'commenting',
				roles: [Roles.PortalAdmin, Roles.Developer],
			},
			{
				primaryText: 'Aladdin Credit Check Audit',
				routerLink: '/portal/fr8paycalllogs',
				icon: 'clipboard-check',
			},
			// {
			//   text: "Daily File Uploads",
			//   routerLink: "/portal/dailyfileuploads",
			//   icon: "user",
			// },
			{
				primaryText: 'File Import',
				routerLink: '/portal/file-import',
				icon: 'upload',
				roles: [Roles.PortalAdmin, Roles.Developer],
			},
			{
				primaryText: 'Marketing Partners',
				routerLink: '/portal/itmarketingpartners',
				icon: 'handshake',
			},
			{
				primaryText: 'Participation Profiles',
				routerLink: '/portal/itparticipantsprofiles',
				icon: 'id-card',
			},
			{
				primaryText: 'Participants',
				routerLink: '/portal/itparticipants',
				icon: 'users-rectangle',
			},
			{
				primaryText: 'Report Permissions',
				routerLink: '/portal/manage-reports',
				roles: [Roles.TsAdmin, Roles.Developer],
				icon: 'chart-column',
			},
			{
				primaryText: 'Sales Offices',
				routerLink: '/portal/salesoffices',
				icon: 'building',
			},
			{
				primaryText: 'User Admin',
				routerLink: '/portal/users',
				icon: 'user-gear',
				roles: [Roles.PortalAdmin, Roles.Developer],
			},
			{
				primaryText: 'User Page Tracking',
				routerLink: '/portal/user-page-tracking/live',
				icon: 'camera-cctv',
				roles: [Roles.PortalAdmin, Roles.Developer],
				children: [
					{
						primaryText: 'Historical',
						routerLink: '/portal/user-page-tracking/historical',
						icon: 'clock-rotate-left',
					},
				],
			},
		],
	},
	{
		primaryText: 'Recovery',
		routerLink: '/portal/recovery',
		icon: 'building-columns',
		roles: [Roles.PortalAdmin, Roles.Developer, Roles.LeadsUser],
	},
];

export const DEVELOPER: MenuItem[] = [
	{
		primaryText: 'Authentication',
		routerLink: null,
		icon: 'solid fa-lock',
		children: [
			{
				primaryText: 'Auth Tools',
				routerLink: '/developer/auth-tools',
				icon: 'solid fa-lock'
			},
			{
				primaryText: 'External Login Tests',
				routerLink: '/developer/test-external-login',
				icon: 'right-to-bracket'
			}
		]
	},
	{
		primaryText: 'Dev Tools',
		routerLink: null,
		icon: 'user-o',
		children: [
			{
				primaryText: 'Auth Tests',
				routerLink: '/developer/auth-tests',
				icon: 'lock'
			},
			{
				primaryText: 'Conversion',
				routerLink: null,
				icon: 'right-left',
				children: [
					{
						primaryText: 'Convert',
						routerLink: '/developer/conversion/convert',
						icon: 'right-left'
					},
					{
						primaryText: 'AtoB Wallets',
						routerLink: '/developer/conversion/atob-wallets',
						icon: 'wallet'
					},
					{
						primaryText: 'Client Debtor Relationships',
						routerLink: '/developer/conversion/client-debtor-relationships',
						icon: 'link'
					},
					{
						primaryText: 'Client Debtor Ties',
						routerLink: '/developer/conversion/client-debtor-ties',
						icon: 'people-arrows'
					},
					{
						primaryText: 'Client Documents',
						routerLink: '/developer/conversion/client-documents',
						icon: 'file-arrow-up'
					},
					{
						primaryText: 'Client Identifiers',
						routerLink: '/developer/conversion/client-identifiers',
						icon: 'id-card'
					},
					{
						primaryText: 'Client Notes',
						routerLink: '/developer/conversion/client-notes',
						icon: 'note-sticky'
					},
					{
						primaryText: 'Customer Documents',
						routerLink: '/developer/conversion/customer-documents',
						icon: 'file-arrow-up'
					},
					{
						primaryText: 'Customer Notes',
						routerLink: '/developer/conversion/customer-notes',
						icon: 'file-lines'
					},
					{
						primaryText: 'Funding Options',
						routerLink: '/developer/conversion/funding-options',
						icon: 'building-columns'
					},
					{
						primaryText: 'Invoice Notes',
						routerLink: '/developer/conversion/invoice-notes',
						icon: 'file-lines'
					},
					{
						primaryText: 'Terms Lookup',
						routerLink: '/developer/conversion/terms-lookup',
						icon: 'file-contract'
					}
				]
			},
			{
				primaryText: 'Create Checklists',
				routerLink: '/developer/create-checklists',
				icon: 'list-check'
			},
			{
				primaryText: 'EOM Processing',
				routerLink: '/developer/eom-processing',
				icon: 'file-invoice-dollar'
			},
			{
				primaryText: 'External File Import',
				routerLink: '/developer/file-import',
				icon: 'upload',
			},
			{
				primaryText: 'Logging Tests',
				routerLink: '/developer/logging-tests',
				icon: 'bug'
			},
			{
				primaryText: 'Recovery Assests',
				routerLink: '/developer/recovery-assets',
				icon: 'arrow-down'
			},
			{
				primaryText: 'Reporting',
				routerLink: '/developer/reports',
				icon: 'chart-line',
			},
			{
				primaryText: 'Safety',
				routerLink: '/developer/safety',
				icon: 'shield-check'
			},
			{
				primaryText: 'Scheduled Jobs',
				routerLink: '/developer/scheduled-jobs',
				icon: 'clock'
			}
		]
	},
	{
		primaryText: 'Logs',
		routerLink: null,
		icon: 'file-spreadsheet',
		children: [
			{
				primaryText: 'Auth Logs',
				routerLink: `/developer/logs/auth`,
				icon: 'file-spreadsheet',
			},
			{
				primaryText: 'Job Logs',
				routerLink: `/developer/logs/job`,
				icon: 'file-spreadsheet',
			},
			{
				primaryText: 'User Tracking Logs',
				routerLink: '/developer/user-page-tracking/live',
				icon: 'camera-cctv',
				children: [
					{
						primaryText: 'Historical',
						routerLink: '/developer/user-page-tracking/historical',
						icon: 'clock-rotate-left',
					},
				],
			},
		],
	},
	{
		primaryText: 'Subscription Builder',
		routerLink: null,
		icon: 'screwdriver-wrench',
		children: [
			{
				primaryText: 'Rates',
				routerLink: '/developer/service-rate-editor',
				icon: 'vector-square',
			},
			{
				primaryText: 'Subscriptions',
				routerLink: '/developer/service-subscription-editor',
				icon: 'object-ungroup',
			}
		],
	},
	{
		primaryText: 'System Settings',
		routerLink: null,
		icon: 'gear',
		children: [
			{
				primaryText: 'ACH',
				routerLink: '/developer/ach',
				icon: 'bank'
			},
			{
				primaryText: 'Feature Flags',
				routerLink: '/developer/feature-flags',
				icon: 'flag'
			},
			{
				primaryText: 'Website Info',
				routerLink: '/developer/website-info',
				icon: 'globe'
			}
		]
	},
	{
		primaryText: 'Third Party',
		routerLink: null,
		icon: 'puzzle',
		children: [
			{
				primaryText: 'API Testing',
				routerLink: '/developer/api-testing',
				icon: 'wrench'
			},
			{
				primaryText: 'Hangfire Dashboard',
				routerLink: '/developer/hangfire',
				icon: 'clock'
			},
			{
				primaryText: 'SignalR',
				routerLink: '/developer/signalr-test',
				icon: 'cloud'
			},
			{
				primaryText: 'Telerik',
				routerLink: '/developer/reporting',
				icon: 'file-chart-pie'
			}
		]
	}
];

export const CONVERTED_LEADS: MenuItem[] = [
	{
		primaryText: 'My Account',
		routerLink: null,
		icon: 'file-text',
		children: [
			{
				primaryText: 'Invoices',
				routerLink: null,
				icon: 'file',
			},
			{
				primaryText: 'Client Info',
				routerLink: null,
				icon: 'address-card',
			},
			{
				primaryText: 'Payment Info',
				routerLink: null,
				icon: 'dollar',
			},
		],
	},
	{
		primaryText: 'My Documents',
		routerLink: null,
		icon: 'file-text-o',
		children: [
			{
				primaryText: 'IFTA',
				routerLink: null,
				icon: 'list-alt',
			},
			{
				primaryText: 'Permits',
				routerLink: null,
				icon: 'credit-card',
			},
			{
				primaryText: 'Licensing',
				routerLink: null,
				icon: 'drivers-license',
			},
		],
	},
	{
		primaryText: 'Factoring Dashboard',
		routerLink: null,
		icon: 'tachometer',
	},
	{
		primaryText: 'Leasing Dashboard',
		routerLink: null,
		icon: 'tachometer',
	},
	{
		primaryText: 'FR8Fuel Dashboard',
		routerLink: null,
		icon: 'tachometer',
	},
];



// WEBPACK FOOTER //
// ./src/app/core/components/menu/side-nav/menu-items.ts